import { useRemoteQuery } from "../useRemote/useRemoteQuery";
import { RemoteApiError } from "../useRemote/types";
import { bookingFavoritesQueryKeys } from "./booking-favorites.query-keys";
import type { BookingFavoritesListResponse } from "./booking-favorites.types";

export function useRemoteFetchBookingFavoritesVehicles(enabled: boolean) {
  return useRemoteQuery<BookingFavoritesListResponse, RemoteApiError>({
    queryKey: bookingFavoritesQueryKeys.vehicles,
    url: "/booking-favorites/vehicles",
    enabled
  });
}
